<template>
  <div class="page-wrapper">
    <search-list
    :projectList="projectList"
    @searchParams="search"
    ></search-list>
    <div >
      <Button v-p="{api:'activityManage/addActivity'}" type="primary" @click.stop="addN++" class="mb16">新增</Button>
      <Button v-p="{api:'activityManage/exportActivityList'}" type="primary" :loading = "btnLoading" @click.stop="exportFile()" class="mb16" style="margin-left:10px">导出</Button>
    </div>
    <add
    :n="addN"
    :projectList="projectList"
    :activityList="activityList"
    @done="getSearchData"
    ></add>
    <check
    :c="addM"
    :item="item"
    :activityFid="activityFid"
    @done="getSearchData"
    ></check>
    <review
    :r="addR"
    :activityFid="activityFid"
    @done="getSearchData"
    ></review>
    <table-list
      :columns="columns"
      :data="data"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changPage"
    >
    </table-list>
  </div>
</template>

<script>

import SearchList from './components/SearchList'
import Add from './components/Add'
import Check from './components/Check'
import Review from './components/Review'
import TableList from 'components/TableList/index';
import { getProjects } from 'api/common'
import {findActivityList ,deleteActivity,exportActivityList} from 'api/activityManageApi'
import {formatDateTime} from "../../../../../utils/format"
import {findWorkOrderTypeList} from 'api/workOrder'

export default {
  name:'activityManage',
  components:{
    SearchList,
    Add,
    TableList,
    Check,
    Review,
  },
  data(){
    return{
      btnLoading:false,
      item:null,
      addN:0,
      addM:0,
      addR:0,
      page:1,
      limit:10,
      current:1,
      total:0,
      activityFid:'',
      loading:false,
      data:[],
      checkItem:null,
      projectList:[],
      activityList:[],
      columns:[
        {
          title:'项目名称',
          key: 'projectName',
          width: 200,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'活动名称',
          key: 'activityName',
          width: 160,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'活动时间',
          key: 'activityDate',
          width: 160,
          align: 'center',
          render:(h,params)=>{
            return h('span',{},this.format(params.row['activityDate']))
          }
        },
        {
          title: ' '
        },
        {
          title:'状态',
          key: 'auditStatusName',
          width: 100,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'创建人',
          key: 'createBy',
          width: 100,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'创建时间',
          key: 'createDate',
          width: 160,
          align: 'center',
          render:(h,params)=>{
            return h('span',{},this.format(params.row['createDate']))
          }
        },
        {
          title: ' '
        },
        {
          title:'审核人',
          key: 'auditZo',
          width: 100,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'审核时间',
          key: 'auditDate',
          width: 160,
          align: 'center',
          render:(h,params)=>{
            return h('span',{},this.format(params.row['auditDate']))
          }
        },
        {
          title: ' '
        },
        {
          title:'操作',
          width: 160,
          fixed:'right',
          align: 'center',
          render:(h,params)=>{
            return [
              h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'activityManage/auditActivity'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.$nextTick( ()=> {
                      this.addR++;
                      this.activityFid = params.row['fid'];
                    })
                  }
                },
                style: {
                  display: params.row['auditStatus']===0?'':'none',
                  marginRight: '10px'
                }
              }, '审核'),
              h('a', {
                on: {
                  click: () => {
                    this.$nextTick( ()=> {
                      this.addM++;
                      this.activityFid = params.row['fid'];
                    })
                  }
                },
                style: {
                  marginRight: '10px'
                }
              }, '查看'),
              h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'activityManage/deleteActivity'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '删除活动',
                      content: '<p>确认删除本条活动？</p>',
                      onOk: () => {
                        const params2 = {
                          activityFid:params.row['fid']
                        }
                        deleteActivity(params2)
                        .then( res => {
                          if(res.code === 0){
                            this.$Message.success('删除成功')
                            this.getSearchData();
                          } else{
                            this.$Message.info( '删除失败')
                          }
                        })
                        .catch( err => {
                          this.$Message.info( '删除失败')
                        })
                        .finally( ()=> {
                          this.isShow = false
                        })
                      }
                    })
                  }
                },
                style: {
                  display: params.row['auditStatus']===0?'':'none',
                }
              }, '删除'),
            ]
          }
        },
        {
          title: ' '
        },
      ]
    }
  },
  created(){
    this.getProjectsData();
    this.getActipityType();
  },
  methods:{
    exportFile(){
      let data = {};
        for (let key in this.searchParams) {
          if(key==='page' || key==='limit') continue;
          data[key] = this.searchParams[key]
        }
        this.btnLoading = true;
        exportActivityList(data).then( res => {
          if(res.headers.count > 10000){
            this.btnLoading = false;
            this.$Modal.info({
              title: '导出合同',
              content:'上限10000条，请选择条件后下载'
            });
          } else{
            let filename = res.headers.filename || 'excel.xls';
            let blob = new Blob([res.data]);
            let url = window.URL.createObjectURL(blob);
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            this.btnLoading = false
          }
        }).catch( err => {
          this.btnLoading = false;
          console.log(err)
        })
    },
    getActipityType(){
      findWorkOrderTypeList({
        parentFid:-1,
        type:2,
      })
      .then(res=>{
        this.activityList = res.data;
      })
    },
    search(data){
      this.searchParams = data
      this.page=1
      this.current=1
      this.getSearchData();
    },
    getSearchData(){
      const params  = {
        ...this.searchParams,
        page:this.page,
        limit:this.limit
      }
      findActivityList(params)
      .then( res => {
        this.data = res.data.rows;
        this.total = res.data.total;
      })
    },
    getProjectsData(){
      getProjects()
      .then(res => {
        this.projectList = res.data;
      })
    },
    changPage(n){
      this.current = n;
      this.page = n;
      this.getSearchData()
    },
    format(data, showTime = true) {
      if (!data) {
        return ''
      }
      return formatDateTime(data, showTime)
    }
  }
}
</script>

<style>

</style>
